import { render } from "./PropertySelectMultipleColoredTag.vue?vue&type=template&id=0a80f496"
import script from "./PropertySelectMultipleColoredTag.vue?vue&type=script&lang=js"
export * from "./PropertySelectMultipleColoredTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__